import { Chart } from 'chart.js'
import Zoom from './plugin'

Chart.register(Zoom)

export default Zoom
